const INTERSECT_OPTIONS = {
  root: null,
  rootMargin: "0% 0% -15% 0%",
  threshold: 0.0,
};

const INTERSECT_EFFECT = {
  fadeIn: "fade-in",
};

const CLASSES = {
  slideFadeIn: "slide-fade-in",
  antiSlideFadeIn: "slide-fade-in--hidden",
};

class IntersectHandler {
  constructor(context) {
    this.context = context;
    this.intersectionObserver = null;
    this.effectType = null;
    this.handled = false;
    this.lastIntersectEntry = null;
    this.intersectEffect = {
      [INTERSECT_EFFECT.fadeIn]: this.fadeIn,
    };
  }

  get scrolledScreen() {
    return window.scrollY + window.innerHeight;
  }

  init() {
    this.intersectHandler = this.handleIntersect.bind(this);

    this.intersectionObserver = new IntersectionObserver(
      this.intersectHandler,
      INTERSECT_OPTIONS,
    );

    this.subscribe();
  }

  setEffect(
    effectType,
    options = {
      once: true,
      defer: true,
    },
  ) {
    this.effectType = effectType;
    this.once = options.once;
    this.defer = options.defer;

    return this;
  }

  hasEffect() {
    return (
      this.effectType !== null &&
      typeof this.intersectEffect[this.effectType] === "function"
    );
  }

  isScrolledBy(target) {
    return this.scrolledScreen >= target.offsetTop;
  }

  isDeffered() {
    return (this.defer && this.lastIntersectEntry === null) || !this.defer;
  }

  handleIntersect(entries) {
    const [firstEntry] = entries;

    if (this.hasEffect()) {
      this.handled = this.intersectEffect[this.effectType].call(
        this,
        firstEntry,
      );

      if (this.handled && this.once) {
        // disconnect intersection observer if set to only once
        this.intersectionObserver.disconnect();
      }
    }

    this.lastIntersectEntry = firstEntry;
  }

  fadeIn({ isIntersecting, target }) {
    if (this.isDeffered() && this.isScrolledBy(target)) {
      // do not apply effect if element has been scrolled by initially
      // register intersect as handled
      return true;
    }

    if (!isIntersecting) {
      // element is not yet visible
      // apply anti-effect styling for effect to take effect once applied
      this.context.classList.add(CLASSES.antiSlideFadeIn);

      // register intersect as not yet handled
      return false;
    }

    // apply effect styling for effect to take effect
    this.context.classList.remove(CLASSES.antiSlideFadeIn);
    this.context.classList.add(CLASSES.slideFadeIn);

    // register intersect as handled
    return true;
  }

  subscribe() {
    window.addEventListener("load", () => {
      this.intersectionObserver.observe(this.context);
    });
  }
}

export { INTERSECT_EFFECT, IntersectHandler };
